module.exports = __webpack_public_path__ + "img/p2-before.5063ad37.png";